import FullWidthSection from "components/components/FullWidthSection/FullWidthSection";
import SingleEndpoint from "components/dataVisualization/dataPageComponents/AdditionalInfoSection/SingleEndpoint";
import { useSwaggerFile } from "contexts/SwaggerFileContext";
import React from "react";
import { transformSwaggerJsonFile } from "utils/apiDocumentationUtils";

import {
  AdditionalInfo,
  ContainerDiv,
  StyledInfo,
  StyledTitle,
  ViewAllApiDocumentationButton,
} from "./style";

export interface DocumentationInformation {
  chart?: string[];
  tile?: string[];
  table?: string[];
}

export enum ExternalDataSource {
  NESO = "National Energy System Operator",
  Elexon = "Elexon",
  MarketParticipants = "Market Participants",
}

interface Props {
  documentationInformation: DocumentationInformation;
  isFullWidth?: boolean;
  source?: ExternalDataSource;
}

const AdditionalInfoSection: React.FC<Props> = ({
  documentationInformation,
  source = ExternalDataSource.NESO,
}: Props) => {
  const { data, noSqlData } = useSwaggerFile();

  const apiEndpoints = data
    ? transformSwaggerJsonFile(data, noSqlData).endpoints
    : [];

  const getSwaggerSpec = (isNoSqlEndpoint: boolean): string =>
    isNoSqlEndpoint ? JSON.stringify(noSqlData) : JSON.stringify(data);

  const filteredDocumentationInformation = Object.entries(
    documentationInformation
  ).filter(
    (locationAndlinkSlugs): locationAndlinkSlugs is [string, string[]] =>
      locationAndlinkSlugs[1] && locationAndlinkSlugs[1].length > 0
  );

  return (
    <AdditionalInfo>
      <FullWidthSection className="is-grey-section">
        <ContainerDiv className="container">
          <div className="columns">
            <div className="column no-grow">
              <StyledTitle className="no-wrap">
                Additional information
              </StyledTitle>
              <StyledInfo>Source: {source}</StyledInfo>
            </div>
            <div className="column">
              <StyledTitle>API documentation</StyledTitle>
              {filteredDocumentationInformation.map(([location, linkSlugs]) => (
                <div key={location}>
                  <StyledInfo>
                    The API endpoints used for the {location} on this page are:
                  </StyledInfo>
                  {linkSlugs.map((linkSlug) => (
                    <SingleEndpoint
                      key={`${linkSlug}-${location}`}
                      linkSlug={linkSlug}
                      getSwaggerSpec={getSwaggerSpec}
                      apiEndpoints={apiEndpoints}
                    />
                  ))}
                </div>
              ))}
              <ViewAllApiDocumentationButton href="/api-documentation">
                View All API Documentation
              </ViewAllApiDocumentationButton>
            </div>
          </div>
        </ContainerDiv>
      </FullWidthSection>
    </AdditionalInfo>
  );
};

export default AdditionalInfoSection;
